import { Cookies } from '@/shared/helpers/Cookies'
import { FoldersStore } from '../FoldersStore'
import { Folder } from '@/shared/interfaces/Folder'
import { ApiHandler } from '@/shared/api/ApiHandler'

let isRefreshing = false

export async function foldersRefresh(): Promise<Folder[]> {
  const { foldersStore } = FoldersStore.get()
  if (isRefreshing) {
    return foldersStore.state.folders// возвращаем уже загруженное
  }
  isRefreshing = true
  //
  // if (!Cookies.get('userId')) {
  //   foldersStore.dispatch(async (state) => {
  //     state.userId = 0
  //     state.folders = []
  //   })
  // } else {
  //   const userId = +Cookies.get('userId')
  //   const response = await ApiHandler.get(`user/${userId}/folders/folders`)
  //   const folders: Folder[] = response.folders
  //
  //   foldersStore.dispatch(async (state) => {
  //     state.userId = userId
  //     state.folders = folders.sort(
  //       (a, b) => a.sorting_number - b.sorting_number,
  //     )
  //
  //     console.log(folders)
  //   })
  // }
  //
  // foldersStore.dispatch(async (state) => {
  //   state.isLoading = false
  // })
  //
  // return foldersStore.state.folders
  try {
    if (!Cookies.get('userId')) {
      await foldersStore.dispatch(async (state) => {
        state.userId = 0
        state.folders = []
      })
    } else {
      const userId = +Cookies.get('userId')
      const response = await ApiHandler.get('folders')
      const folders: Folder[] = response.folders

      await foldersStore.dispatch(async (state) => {
        state.userId = userId
        state.folders = folders.sort((a, b) => a.sorting_number - b.sorting_number)
      })
    }

    await foldersStore.dispatch(async (state) => {
      state.isLoading = false
    })

    return foldersStore.state.folders
  } finally {
    isRefreshing = false
  }
}
